import { render, staticRenderFns } from "./Testimony.vue?vue&type=template&id=f88057fc&"
import script from "./Testimony.vue?vue&type=script&lang=js&"
export * from "./Testimony.vue?vue&type=script&lang=js&"
import style0 from "./Testimony.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports